



















































































































































































































































































































































































































































































































































































































































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { ReportIncomeTableData } from "../table-data/table-data-types"
import { Indicator } from "../../../common/types/Indicator"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { ReportIncomeFilterSettingsForm } from "../settings-form/ReportIncomeFilterSettingsForm";
import { Segmentation } from "../../../common/types/roots/fields"
import { Classificator } from "../../../common/types/Classificator"
import { ReportIncomeTemplate4Dspk, ReportIncomeTemplate4Msu, ReportIncomeTemplate4Raion } from "../ReportIncomeResponse"
import { ReportIncomeRow } from "../Row"
import { getIncomeApplicability, reportIncomePercentKeys } from "../report-income"

type Column = 'action' | 'kat' | 'cls' | 'pcl' | 'spf' | 'region_name' | 'total_sum' | 'period_sum' | 'sumrg' | 'deviation_period' | 'percent_to_period' | 'deviation_annual' | 'percent_to_year' | 'total_sum_past' | 'period_sum_past' | 'sumrg_past' | 'deviation_annual_past' | 'deviation_period_past' | 'deviation_past' | 'growth'

export interface TableField {
    key: Column,
    label: string,
    active: boolean
}

// Число строк, одновременно находящихся в DOM
const WINDOW_SIZE = 200
// Запас строк выше видимой области при прокрутке
const SCROLL_BUFFER = 60

type VirtualMode = 'tree' | 'flat' | 'regionKbk'

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class ReportIncome extends Vue {

    @Prop({
        type: Object,
        required: true,
    })
    public tableData!: ReportIncomeTableData

    @Prop({
        type: Array,
        required: true
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]
    

    @Prop({
        type: Date,
        required: true
    })
    private readonly reportDate!: Date
    private readonly nextYear: number = this.reportDate.getFullYear()

    @Prop({
        type: Boolean,
        required: false,
    })
    public prevYear!: boolean

    @Prop({
        type: Array,
        required: true,
    })
    public regions!: object

    @Prop({
        type: Object,
        required: true,
    })
    public filterSettings!: ReportIncomeFilterSettingsForm

    public template4Indicators: Column[] = ['total_sum', 'period_sum', 'sumrg', 'percent_to_period']

    
    public template4TotalRows = this.tableData.template4_items_structured_dspk?.length ?? 0
    public template4PerPage = 4
    
    public template4CurrentPage = 1
    public template4CurrentDspk: ReportIncomeTemplate4Dspk[] = this.tableData.template4_items_structured_dspk?.slice(0, 4) ?? []
    public template4StructuredRegions: (ReportIncomeTemplate4Raion | ReportIncomeTemplate4Msu)[] = this.tableData.template4_items_structured_regions ?? []

    public handlePageChange(page: number) {
        const indexedPage = page - 1
        this.template4CurrentPage = page
        const startIndex = indexedPage * this.template4PerPage
        const endIndex = startIndex + this.template4PerPage
        this.template4CurrentDspk = this.tableData.template4_items_structured_dspk?.slice(startIndex, endIndex) ?? []
    }

    public activeIncomes: string[] = this.incomes.filter(it => it.active).map(it => it.key)

    // public variant: 'UNFULFILLED' | 'OVERFULFILLED' = 'UNFULFILLED'
    public tableFields: TableField[] = []
    public indicators: Indicator[] = []

    public columnsNameMap: Record<Column, string> = {
        'action': '',
        'kat': '',
        'cls': '',
        'pcl': '',
        'spf': '',
        'region_name': 'Наименование',
        'total_sum': `План на ${this.nextYear} год`,
        'period_sum': 'План на отчетный период',
        'sumrg': 'Фактическое исполнение',
        'deviation_period': 'Отклонение к периоду',
        'percent_to_period': '% к периоду',
        'deviation_annual': 'Отклонение к годовому плану',
        'percent_to_year': '% к году',
        'total_sum_past': `План на ${this.nextYear - 1} год`,
        'period_sum_past': 'План на аналогичный период прошлого года',
        'sumrg_past': 'Фактическое поступление на аналогичный период прошлого года',
        'deviation_annual_past': 'Отклонение к годовому плану',
        'deviation_period_past': 'Отклонение к периоду',
        'deviation_past': 'Темп роста, %',
        'growth': 'Отклонение',
    }
    public totalExpand: boolean = true

    private open = false;

    private treeData: any = [];

    private keyCounter = 0;

    private settings: ReportIncomeFilterSettingsForm = this.filterSettings;

    private itemsData: ReportIncomeTableData  = this.tableData;

    private regionsList: any = [];

    private segmentations: Segmentation[] = this.settings.segmentations?.filter(s => s.active).map(s => s.value) ?? []

    /**
     * Эффективные значения переключателей: недоступные при текущей разрезности считаются выключенными
     * (в форме значение может «застрять» после смены разрезности или прийти из старого шаблона).
     */
    get applicability() {
        return getIncomeApplicability(this.segmentations, !!this.settings.isTree)
    }

    get effIsTree(): boolean {
        return this.applicability.isTree && !!this.settings.isTree
    }

    get effPrevYear(): boolean {
        return this.applicability.prevYear && !!this.settings.prevYear
    }

    get effRegionsTotal(): boolean {
        return this.applicability.regionsTotal && !!this.settings.regionsTotal
    }

    get effDecodingActualRegionalBudget(): boolean {
        return this.applicability.decodingActualRegionalBudget && !!this.settings.decodingActualRegionalBudget
    }

    /** «Наименование перед КБК»: действует только для «КБК + дерево» и «Регион → КБК» */
    get nameBeforeKbk(): boolean {
        return this.applicability.nameBeforeKbk && !!this.settings.nameBeforeKbk
    }

    /** Разрезность только «КБК» + эффективное дерево */
    get isKbkTree(): boolean {
        return this.segmentations.length === 1 && this.segmentations[0] === 'KBK' && this.effIsTree
    }

    /** Разрезность только «КБК» без дерева - плоский список */
    get isKbkFlat(): boolean {
        return this.segmentations.length === 1 && this.segmentations[0] === 'KBK' && !this.effIsTree
    }

    get hasDecodingItems(): boolean {
        return this.effDecodingActualRegionalBudget && (this.itemsData.template1_regional_budget_decrypt_items?.length ?? 0) > 0
    }

    /** Поля показателей (без служебных колонок действия/КБК/наименования) */
    get indicatorFields(): TableField[] {
        return this.tableFields.filter(f => f.active && !['action', 'kat', 'cls', 'pcl', 'spf', 'region_name'].includes(f.key))
    }

    /** Колонки дерева КБК: при nameBeforeKbk «Наименование» сразу после кнопки раскрытия */
    get orderedTableFields(): TableField[] {
        if (!this.nameBeforeKbk) {
            return this.tableFields
        }
        const name = this.tableFields.find(f => f.key === 'region_name')
        const rest = this.tableFields.filter(f => f.key !== 'region_name')
        const actionIdx = rest.findIndex(f => f.key === 'action')
        if (!name) {
            return rest
        }
        rest.splice(actionIdx + 1, 0, name)
        return rest
    }

    // Состояние виртуального скроллинга (одновременно рендерится только одна таблица)
    private virtualStart = 0
    private virtualEnd = WINDOW_SIZE
    private rowHeight = 40   // оценка высоты для ещё не измеренных строк
    private topSpacerHeight = 0
    private bottomSpacerHeight = 0
    private isScrolling = false
    // Поля с префиксом _ Vue 2 не проксирует, поэтому они нереактивны
    private _scrollRaf: number | null = null
    private _scrollPointerTimer: any = null
    private _rowHeights: number[] = []
    private _prefixSum: number[] = [0]

    /** Какая из виртуализируемых таблиц сейчас рендерится (зеркалит цепочку v-if в шаблоне); null - ни одна */
    get virtualMode(): VirtualMode | null {
        const segs = this.segmentations
        if (segs.length === 2 && segs[0] === 'KBK' && segs[1] === 'REGION' && this.itemsData.template4_items) {
            return null
        }
        if (this.isKbkTree && this.itemsData.template2_items_tree) {
            return 'tree'
        }
        if (segs.length === 1 && segs[0] === 'REGION' && this.itemsData.template1_items) {
            return null
        }
        if (this.isKbkFlat && this.itemsData.template2_items) {
            return 'flat'
        }
        if (segs.length === 2 && segs[0] === 'REGION' && segs[1] === 'KBK' && this.itemsData.template3_items) {
            return 'regionKbk'
        }
        return null
    }

    /**
     * Строки активной таблицы, которые реально выводятся.
     * regionKbk: элементы вида { row, index }, где index - индекс в исходном template3_items
     * (нужен для openChildsTemplate3).
     */
    get virtualSource(): any[] {
        switch (this.virtualMode) {
            case 'tree':
                return this.treeData.filter((item: any) => item.visible)
            case 'flat':
                return this.itemsData.template2_items as any[]
            case 'regionKbk': {
                const result: { row: any, index: number }[] = []
                const items = this.itemsData.template3_items as any[]
                for (let index = 0; index < items.length; index++) {
                    const row = items[index]
                    if (row.type === 'raionmsu' || ((row.type === 'region' || row.type === 'classificator') && row.visible)) {
                        result.push({ row, index })
                    }
                }
                return result
            }
            default:
                return []
        }
    }

    /** Срез virtualSource, реально находящийся в DOM */
    get virtualRows(): any[] {
        return this.virtualSource.slice(this.virtualStart, this.virtualEnd)
    }

    /** Число колонок активной таблицы - для colspan spacer-строк */
    get activeColumnCount(): number {
        switch (this.virtualMode) {
            case 'tree':
                // кнопка + КБК (4) + наименование + показатели
                return 1 + 4 + 1 + this.indicatorFields.length
            case 'flat':
                // region_name занимает 2 колонки + остальные активные
                return 2 + this.tableFields.filter(f => f.key !== 'region_name' && f.active).length
            case 'regionKbk':
                return 1 + this.activeIncomes.length + 1 + this.indicatorFields.length
            default:
                return 1
        }
    }

    private mounted() {
        this.$nextTick(() => {
            const container = this.$refs.tableContainer as HTMLElement | undefined
            if (!container || !this.virtualMode) return
            this.updateRowHeightEstimate()
            this.initRowHeights(this.virtualSource.length)
            this.virtualEnd = Math.min(WINDOW_SIZE, this.virtualSource.length)
            // Сразу выставляем нижний spacer, чтобы полоса прокрутки соответствовала всему списку
            this.syncVirtualWindow()
            // Capture-фаза ловит прокрутку любого элемента (контейнера, родителя или окна)
            window.addEventListener('scroll', this.onScroll, { passive: true, capture: true })
        })
    }

    private beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, true)
        if (this._scrollRaf !== null) cancelAnimationFrame(this._scrollRaf)
        if (this._scrollPointerTimer !== null) clearTimeout(this._scrollPointerTimer)
    }

    // Оценка высоты строки по первой отрисованной строке данных
    private updateRowHeightEstimate() {
        const container = this.$refs.tableContainer as HTMLElement | undefined
        const firstRow = container?.querySelector('tbody tr[data-row-index]') as HTMLElement | null
        if (firstRow && firstRow.offsetHeight > 0) {
            this.rowHeight = firstRow.offsetHeight
        }
    }

    // Пересоздаёт _rowHeights (все равны rowHeight) и _prefixSum
    private initRowHeights(count: number) {
        this._rowHeights = new Array(count).fill(this.rowHeight)
        this.rebuildPrefixSum()
    }

    // Полный пересчёт префиксных сумм, O(n); не вызывает перерисовку
    private rebuildPrefixSum() {
        const n = this._rowHeights.length
        const ps = new Array(n + 1)
        ps[0] = 0
        for (let i = 0; i < n; i++) {
            ps[i + 1] = ps[i] + this._rowHeights[i]
        }
        this._prefixSum = ps
    }

    // Бинарный поиск: наибольший i, для которого _prefixSum[i] <= scrollPos
    private findRowAtScrollPos(scrollPos: number): number {
        if (this._prefixSum.length < 2) return Math.floor(scrollPos / this.rowHeight)
        let lo = 0
        let hi = this._prefixSum.length - 2
        while (lo < hi) {
            const mid = (lo + hi + 1) >> 1
            if (this._prefixSum[mid] <= scrollPos) lo = mid
            else hi = mid - 1
        }
        return lo
    }

    // Измеряет высоты отрисованных строк и обновляет _prefixSum, если что-то изменилось
    private measureRenderedRows() {
        const container = this.$refs.tableContainer as HTMLElement | undefined
        if (!container || !this._rowHeights.length) return
        const rows = container.querySelectorAll<HTMLElement>('tbody tr[data-row-index]')
        let changed = false
        rows.forEach(row => {
            const idx = parseInt(row.dataset.rowIndex ?? '')
            const h = row.offsetHeight
            if (!isNaN(idx) && h > 0 && idx < this._rowHeights.length && this._rowHeights[idx] !== h) {
                this._rowHeights[idx] = h
                changed = true
            }
        })
        if (changed) this.rebuildPrefixSum()
    }

    // Пересчитывает окно рендера по текущей позиции прокрутки
    private syncVirtualWindow() {
        const container = this.$refs.tableContainer as HTMLElement | undefined
        if (!container || !this.virtualMode) return

        // Начало виртуальных данных в координатах viewport: верхний spacer (если есть) или первая строка
        // данных за вычетом высоты spacer'а. Так учитываются thead и статичные строки над данными.
        const anchor = (container.querySelector('tbody tr.vs-spacer-top') ??
            container.querySelector('tbody tr[data-row-index]')) as HTMLElement | null
        let scrolledIntoData = 0
        if (anchor) {
            const isSpacer = anchor.classList.contains('vs-spacer-top')
            const dataTop = anchor.getBoundingClientRect().top - (isSpacer ? 0 : this.topSpacerHeight)
            // Верх видимой области: контейнер, если он сам прокручивается, иначе верх окна
            const viewportTop = Math.max(container.getBoundingClientRect().top, 0)
            scrolledIntoData = Math.max(0, viewportTop - dataTop)
        }

        const total = this.virtualSource.length
        const firstVisibleRow = this.findRowAtScrollPos(scrolledIntoData)

        // SCROLL_BUFFER строк выше видимой области, остальное - вниз
        const rawStart = Math.max(0, firstVisibleRow - SCROLL_BUFFER)
        const rawEnd = Math.min(total, rawStart + WINDOW_SIZE)
        // Возле конца списка сдвигаем начало вверх, чтобы окно оставалось WINDOW_SIZE
        const adjustedStart = Math.max(0, rawEnd - WINDOW_SIZE)

        this.virtualStart = adjustedStart
        this.virtualEnd = rawEnd

        // Высоты spacer'ов - точные, из префиксных сумм
        const ps = this._prefixSum
        this.topSpacerHeight = ps.length > adjustedStart ? ps[adjustedStart] : adjustedStart * this.rowHeight
        this.bottomSpacerHeight = ps.length > total
            ? Math.max(0, ps[total] - ps[rawEnd])
            : Math.max(0, (total - rawEnd) * this.rowHeight)

        // После обновления DOM измеряем реальные высоты (без перерисовки)
        this.$nextTick(() => this.measureRenderedRows())
    }

    private onScroll() {
        // На время прокрутки отключаем pointer-events, чтобы не пересчитывать hover
        if (!this.isScrolling) this.isScrolling = true
        if (this._scrollPointerTimer !== null) clearTimeout(this._scrollPointerTimer)
        this._scrollPointerTimer = setTimeout(() => { this.isScrolling = false }, 150)

        // Нестрогое сравнение: Vue 2 не проксирует _-поля, до первой записи они undefined, а не null
        // eslint-disable-next-line eqeqeq
        if (this._scrollRaf != null) return
        this._scrollRaf = requestAnimationFrame(() => {
            try {
                this.syncVirtualWindow()
            } finally {
                this._scrollRaf = null
            }
        })
    }

    // Пересинхронизация окна при смене списка строк (раскрытие/сворачивание, смена режима)
    @Watch('virtualSource')
    private onVirtualSourceChanged() {
        this.$nextTick(() => {
            if (!this.virtualMode) return
            this.updateRowHeightEstimate()
            this.initRowHeights(this.virtualSource.length)
            this.syncVirtualWindow()
        })
    }

    @Watch('virtualMode')
    private onVirtualModeChanged() {
        // Смена режима: сбрасываем окно в начало
        this.virtualStart = 0
        this.virtualEnd = Math.min(WINDOW_SIZE, this.virtualSource.length)
        this.topSpacerHeight = 0
        this.bottomSpacerHeight = 0
    }

    private created() {
        this.keyCounter += 1;
        this.indicators = cloneDeep(this.propIndicators);
        this.settings = cloneDeep(this.filterSettings);
        this.itemsData = cloneDeep(this.tableData);
        this.regionsList = cloneDeep(this.regions);
        this.constructTableFields();
        this.treeStructure();
        this.handlePageChange(1)

        // this.$watch(
        //     () => this.filterSettings,
        //     () => {
        //         this.constructTableFields();
        //         this.treeStructure();
        //         this.keyCounter += 1;
        //     },
        //     { deep: true }
        // );
        
    }

    private treeStructure() {
        this.treeData = [];
        if (this.isKbkTree && this.itemsData.template2_items_tree) {
            const tree = []
            for (const data of this.itemsData.template2_items_tree as any) {
                const { cls_list, ...k } = data;
                k.visible = true;
                k.open = this.open;
                tree.push(k)
                for (const cls of data.cls_list) {
                    const { pcl_list, ...c } = cls;
                    c.open = this.open;
                    c.visible = false;
                    tree.push(c)
                    for (const pcl of cls.pcl_list) {
                        const { spf_list, ...p } = pcl;
                        p.open = this.open;
                        p.visible = false;
                        tree.push(p);
                        for (const spf of pcl.spf_list) {
                            // копия с явным visible=false: иначе свойство нереактивно и computed списка не обновится
                            tree.push({ ...spf, visible: false })
                        }
                    }
                }
            }
            this.treeData = tree;
        }
        if (this.segmentations.length === 1 && this.segmentations[0] === 'REGION') {
            const tree = [];
            for (const data of (this.itemsData.template1_items ?? []) as any) {
                if (data.children) {
                    const { chidlren, ...reg } = data;
                    reg.visible = true;
                    if (data.children.length > 0) {
                        reg.open = this.open;
                    }
                    tree.push(reg);
                    for (const child_reg of data.children) {
                        tree.push(child_reg)
                    }
                } else {
                    data.visible = true;
                    tree.push(data)
                }
            }
            this.treeData = tree;
        }
    }

    private constructTableFields() {
        const tempTableFields: TableField[]  = []

        // Показатели (работаем с копией: propIndicators - живая форма, служебные active не должны в неё попадать)
        cloneDeep(this.propIndicators).forEach(indicator => {
            const key: Column = indicator.key as unknown as Column
            if (this.isKbkTree) {
                if (indicator.key == 'action' || indicator.key == 'kat' || indicator.key == 'cls' || indicator.key == 'pcl' || indicator.key == 'spf') {
                    indicator.active = true;
                }
            } else {
                if (indicator.key == 'action' || indicator.key == 'kat' || indicator.key == 'cls' || indicator.key == 'pcl' || indicator.key == 'spf') {
                    indicator.active = false;
                }
            }
            if (this.effPrevYear) {
                if (indicator.key == 'total_sum_past' || indicator.key == 'period_sum_past' || indicator.key == 'sumrg_past' || indicator.key == 'deviation_annual_past' || indicator.key == 'deviation_period_past' || indicator.key == 'deviation_past' || indicator.key == 'growth') {
                    indicator.active = true;
                }
            } else {
                if (indicator.key == 'total_sum_past' || indicator.key == 'period_sum_past' || indicator.key == 'sumrg_past' || indicator.key == 'deviation_annual_past' || indicator.key == 'deviation_period_past' || indicator.key == 'deviation_past' || indicator.key == 'growth') {
                    indicator.active = false;
                }
            }

            if (this.segmentations.length === 2) {
                if (['kat', 'cls', 'pcl', 'spf'].includes(key)) {
                    indicator.active = this.activeIncomes.includes(key)
                }
            }
            tempTableFields.push({ key: key, label: this.columnsNameMap[key], active: indicator.active })
        })

        this.tableFields = tempTableFields
    }

    public formatDigitsGrouping = formatDigitsGrouping

    private openAll() {
        if (this.segmentations.length === 2 && this.segmentations[0] === 'REGION' && this.segmentations[1] === 'KBK' && this.itemsData.template3_items) {
            this.totalExpand = !this.totalExpand
            this.itemsData.template3_items?.forEach(i => {
                i.is_expanded = this.totalExpand
                if (i.level > 0) {
                    i.visible = this.totalExpand
                }
            })
        } else {
            this.open = !this.open;
            for (const r of this.treeData) {
                if (this.isKbkTree) {
                    if (r.kat) {
                        r.open = this.open;
                    } else {
                        r.visible = this.open;
                    }
                }
                if (this.segmentations.length === 1 && this.segmentations[0] === 'REGION') {
                    if (r.open !== undefined) {
                        r.open = this.open;
                    } else {
                        r.visible = this.open;
                    }
                }
            }
        }
    }

    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor.report_income'
        const text: string = String(this.$t(`${translationKey}.${key}`))

        return text
    }
    
    private openChilds(item: any) {
        item.open = !item.open;
        if (item.kat) {
            if (!item.open) {
                for (const r of this.treeData.filter((x: any) => x.parent_kat == item.kat)) {
                    r.open = item.open;
                    r.visible = item.open;
                }
            } else {
                for (const r of this.treeData.filter((x: any) => x.cls && x.parent_kat == item.kat)) {
                    r.visible = item.open;
                }
            }
        }
        if (item.cls) {
            if (!item.open) {
                for (const r of this.treeData.filter((x: any) => (x.parent_kat == item.parent_kat) && (x.parent_cls == item.cls))) {
                    r.open = item.open;
                    r.visible = item.open;
                }
            } else {
                for (const r of this.treeData.filter((x: any) => x.pcl && (x.parent_cls == item.cls) && (item.parent_kat == x.parent_kat))) {
                    r.visible = item.open;
                }
            }
        }
        if (item.pcl) {
            for (const r of this.treeData.filter((x: any) => x.spf && (x.parent_pcl == item.pcl) && (x.parent_cls == item.parent_cls) && (x.parent_kat == item.parent_kat))) {
                r.visible = item.open;
            }
        }
        if (item.children) {
            for (const r of this.treeData.filter((x: any) => !x.children && x.region_code.slice(0, 4) === item.region_code.slice(0, 4))) {
                r.visible = item.open;
            }
        }
    }

    /**
     * Округление для вывода. С «Округлять до» - как раньше; без него проценты (key из reportIncomePercentKeys)
     * показываются с 2 знаками (sit-py отдаёт их с 5 знаками), суммы - как есть.
     */
    private valueRound(value: any, key?: string) {
        if (!this.settings.roundUp && key && reportIncomePercentKeys.includes(key) && value !== null && value !== undefined && value !== '' && !isNaN(Number(value))) {
            return formatDigitsGrouping(Math.round(Number(value) * 100) / 100)
        }
        if (this.settings.roundUp) {
            const roundUpFactor = Math.pow(10, Number(this.settings.roundUpTo));
            if (Number(this.settings.roundUpTo) > 0) {
                return formatDigitsGrouping(Math.round(value * roundUpFactor) / roundUpFactor);
            }
            return formatDigitsGrouping(Math.round(value));
        }
        return formatDigitsGrouping(value)
    }

    private openChildsTemplate3(parent_index: number, childs_count: number) {
         if (this.segmentations.length === 2 && this.segmentations[0] === 'REGION' && this.segmentations[1] === 'KBK' && this.itemsData.template3_items) {
            if (parent_index < 0 || parent_index >= this.itemsData.template3_items.length) {
                return;
            }
            const parent = this.itemsData.template3_items[parent_index]
            parent.is_expanded = !parent.is_expanded

            const start = parent_index + 1
            const end = parent_index + childs_count
            const startSafe = Math.max(0, start);
            const endSafe = Math.min(this.itemsData.template3_items.length - 1, end);
            for (let i = startSafe; i <= endSafe; i++) {
                this.itemsData.template3_items[i].visible = parent.is_expanded;
                this.itemsData.template3_items[i].is_expanded = parent.is_expanded;
            }
        }
    }

    private openChildsTemplate4(raion: ReportIncomeTemplate4Raion) {
        raion.is_childs_visible = !raion.is_childs_visible
    }

    private openChildsTemplate4All() {
        if (this.tableData && this.tableData.template4_items_structured_regions) {
            this.totalExpand = !this.totalExpand
            this.tableData.template4_items_structured_regions.forEach(region => {
                if ('is_childs_visible' in region) {
                    region.is_childs_visible = this.totalExpand
                }
            })
        }
        
    }

    private getTemplate4Items(dspk: string, region_code: string, indicator: keyof ReportIncomeRow) {
        if (this.tableData && this.tableData.template4_items) {
            if (dspk in this.tableData.template4_items && region_code in this.tableData.template4_items[dspk]) {
                return this.valueRound(this.tableData.template4_items[dspk][region_code][indicator], indicator)
            }
        }
        return ""
    }


}
